import React, { useState, useEffect, FC } from "react";
import { Table, Button, Input, DatePicker, Tooltip } from "antd";
import { YHModal } from "@/components/YHModal";
import { usePurchaseRoDetailsModel } from "./purchaseRoDetailsModel";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IMaterialBase, IMaterialDetail, IMaterialSearchFields, materialService } from "../../../../base/material/materialService"
import { YhBut } from "@/components/YhButton";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { IPurchaseDetails } from "../../purchaseRoType"
import { formatNum, formatInt, formatDiscount, formatIntPoint } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
const { RangePicker } = DatePicker;
enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}
export const AddGoodsModal: FC<RouterParamType> = ({ id, mode }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { addModalVisible: visible, detailAddForm, initPgCfg, detailEditForm, workDataSource, workPgCfg, addDataSource, searchWorkData, setWorkDataSource, resetWorkloadData, setSearchWorkData, setAddDataSource, transformsToRoDetailList, workloadData, setAddModalVisible, } = usePurchaseRoDetailsModel();
    useEffect(() => {
        if (visible && mode == "add") {
            workloadData(initPgCfg, { supplierCode: detailAddForm.supplierCode })
            setSearchWorkData({ supplierCode: detailAddForm.supplierCode })
        } else if (visible && mode == "edit") {
            workloadData(initPgCfg, { supplierCode: detailEditForm.supplierCode })
            setSearchWorkData({ supplierCode: detailEditForm.supplierCode })
        }
    }, [detailAddForm.supplierCode, detailEditForm.supplierCode, visible])
    const column = (optype: number) => [
        {
            // title: '商品编号',
            title: Locale['Material Code'],
            width: 100,
            dataIndex: 'materialCode',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称-英文',
            title: Locale['Material Name En'],
            width: 100,
            dataIndex: 'materialNameEn',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称',
            title: Locale['Material Name'],
            width: 100,
            dataIndex: 'materialName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        // }, {
        //     // title: '替换编号',
        //     title: Locale['Manufacturer Codes'],
        //     width: 150,
        //     dataIndex: 'replaceCode',
        //     render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        // }, {
        //     // title: '单位',
        //     title: Locale['Unit'],
        //     width: 120,
        //     dataIndex: 'unitName',
        }, {
            // title: '采购数量',
            title: Locale['Purchase Qty'],
            width: 120,
            dataIndex: 'num',
        }, {
            // title: '采购单价',
            title: Locale['Unit Price'],
            width: 120,
            dataIndex: 'price',
        }, {
            // title: '采购金额',
            title: Locale['Purchase Amount'],
            width: 120,
            dataIndex: 'amount',
        }, {
            // title: '退货数量',
            title: Locale['Return Qty'],
            width: 120,
            dataIndex: 'returnNum',
            editable: true,
        }, {
            // title: '已退数量',
            title: Locale['Returned quantity'],
            width: 120,
            dataIndex: 'preturnNum',
        }, {
            // title: '采购单号',
            title: Locale['Purchase Doc No.'],
            width: 120,
            dataIndex: 'purchaseCode',
        }, {
            // title: '仓库',
            title: Locale['Warehouse'],
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            // title: '货位',
            title: Locale['Shelf'],
            width: 120,
            dataIndex: 'shelfCode',
        }, {
            // title: '品牌',
            title: Locale['Material Brand'],
            width: 120,
            dataIndex: 'brandName',
        }, {
            // title: '操作',
            title: Locale['Operation'],
            width: 120,
            fixed: "right",
            render: (text: any, record: any) => optype == OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    // txt="添加"
                    txt={Locale['Add']}
                    click={() => add(record)}
                    disabled={
                        !!addDataSource.find(item => item.id === record.id)
                        || record.num == record.preturnNum}
                />
            ) : (
                    <YhBut
                        type="delete"
                        // txt="删除"
                        txt={Locale['Delete']}
                        click={() => remove(record)}
                    />
                )
        }
    ];
    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IPurchaseDetails, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType == OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })
    const notHandleSave = (row: IPurchaseDetails) => {
        let { num, preturnNum, returnNum } = row
        num = +formatIntPoint(num);
        preturnNum = +formatIntPoint(preturnNum);
        returnNum = +formatIntPoint(returnNum);
        let surplusNum = num - preturnNum //采购数量 - 已退数量
        let newRow = {
            ...row,
            returnNum: +formatIntPoint(returnNum, surplusNum, "退货数量≥采购数量+已退数量")
        }
        const index = workDataSource.findIndex((item) => row.id === item.id);
        const item = workDataSource[index];
        workDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkDataSource([...workDataSource])
    }
    const handleSave = (row: IPurchaseDetails) => {
        let { num, preturnNum, returnNum } = row
        num = +formatIntPoint(num);
        preturnNum = +formatIntPoint(preturnNum);
        returnNum = +formatIntPoint(returnNum);
        let surplusNum = num - preturnNum //采购数量 - 已退数量
        let newRow = {
            ...row,
            returnNum: +formatIntPoint(returnNum, surplusNum, "退货数量≥采购数量+已退数量")
        }
        const index = addDataSource.findIndex((item) => row.id === item.id);
        const item = addDataSource[index];
        addDataSource.splice(index, 1, { ...item, ...newRow });
        setAddDataSource([...addDataSource])
    }
    const add = async (record: IPurchaseDetails) => {
        setAddDataSource(origin => [...origin, record])
    }
    const remove = async (record: IPurchaseDetails) => {
        const filterAddDataSource = addDataSource.filter(item => item.id != record.id)
        setAddDataSource(filterAddDataSource)
    }
    const onOK = async () => {
        transformsToRoDetailList(mode)
        onCancel()
    }
    const onCancel = () => {
        setAddModalVisible(false);
        setAddDataSource([])
        setSearchWorkData({})
    };
    const rightChildren = <div className="flex">
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialCode}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialCode: e.target.value }) }}
            // placeholder="商品编码"
            onPressEnter={() => workloadData(initPgCfg)}
            placeholder={Locale['Material Code']}
        />
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialName}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialName: e.target.value }) }}
            // placeholder="商品名称"
            onPressEnter={() => workloadData(initPgCfg)}
            placeholder={Locale['Material Name']}
        />
        <Button onClick={() => workloadData()} style={{ margin: "0px 5px 0px 10px" }} shape="round">{Locale["Search"]}</Button>
        <Button onClick={() => { mode == "add" ? resetWorkloadData({ supplierCode: detailAddForm.supplierCode }) : resetWorkloadData({ supplierCode: detailEditForm.supplierCode }) }} shape="round">{Locale["Reset"]}</Button>
    </div>

    return <YHModal
        visible={visible}
        onOk={onOK}
        onCancel={onCancel}
        // title="采购退货单-选择配件"
        title={Locale["Purchase Return Doc -Select Materials"]}
        width={1000}
        bodyHeight={750}
        showFooter={true}
    >
        <YhBox title={Locale["List of materials to be selected"]} rightChildren={rightChildren} style={{ marginBottom: "15px" }}>
            <Table
                // size="small"

                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={newSelectColumns(OPT_TYPE.ADD) as ColumnsType<IPurchaseDetails>}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                dataSource={workDataSource}
                pagination={{
                    ...workPgCfg,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        workloadData({ pageNum, pageSize });
                    }
                }}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        {/* <YhBox title="已选配件列表"> */}
        <YhBox title={Locale["List of selected materials"]}>
            <Table
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={newSelectColumns(OPT_TYPE.REMOVE) as ColumnsType<IPurchaseDetails>}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                dataSource={addDataSource}
                pagination={false}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}